import React from 'react';
import { getTheme } from '@fluentui/react';
import { IPSpinner, IPText } from 'baseComponents';
import { IPProgressIndicator } from 'baseComponents/ProgressIndicator/IPProgressIndicator';
import { IPSpinnerSize } from 'baseComponents/Spinner/IPSpinner';
import { IPStack } from 'baseComponents/Stack/IPStack';
import AppContext from 'App/AppContext';
import { globalStackTokensGapSmall } from 'globalStyles';

interface IOverlayLoaderProps {
  text?: string;
  showProgress?: boolean;
  progressPercent?: number;
  progressLabel?: string;
}

const OutlookOverlayLoader: React.FunctionComponent<IOverlayLoaderProps> = (props: IOverlayLoaderProps) => {
  const appContext = React.useContext(AppContext);
  const theme = getTheme();

  return (
    <IPStack
      verticalFill
      styles={{
        root: {
          position: 'absolute',
          margin: 'auto',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 999,
        },
      }}
      horizontalAlign="center"
      verticalAlign="center"
    >
      <IPStack.Item
        styles={{
          root: {
            padding: 20,
            border: '2px solid',
            borderColor: appContext.useDarkMode ? theme.palette.themeDarkAlt : theme.palette.themeLighterAlt,
            background: appContext.useDarkMode ? theme.palette.themeDarker : theme.palette.themeLighter,
          },
        }}
      >
        <IPStack tokens={globalStackTokensGapSmall}>
          <IPSpinner
            styles={{ root: { paddingBottom: props.text ? 5 : undefined } }}
            size={IPSpinnerSize.large}
          ></IPSpinner>
          {props.text && <IPText variant="medium">{props.text}</IPText>}
          {props.showProgress && (
            <IPProgressIndicator barHeight={6} label={props.progressLabel} percentComplete={props.progressPercent} />
          )}
        </IPStack>
      </IPStack.Item>
    </IPStack>
  );
};

export default OutlookOverlayLoader;
